import type { CoinPriceCache } from 'oscar-typedef'
import APIRequest from '../../APIRequest'
import type APIResponse from '../../APIResponse'
import InterfaceAPI from '../../InterfaceAPI'
import type ICoinsAPI from './ICoinsAPI'

class CoinsAPI implements ICoinsAPI {
  private basePath = '/coins'
  constructor(private fetcher: InterfaceAPI) {}

  async coinMarket(
    params: CoinPriceCache.Coins.Markets.Request.Params,
  ): Promise<CoinPriceCache.Coins.Markets.Response.Body> {
    const request = new APIRequest({
      url: this.basePath + `/markets`,
      method: 'GET',
      urlParams: params,
      // withCredentials: true,
    })
    const res: APIResponse<
      unknown,
      CoinPriceCache.Coins.Markets.Response.Body,
      typeof request
    > = await this.fetcher.send(request)
    return res.data
  }
}

export default CoinsAPI
